export enum OpenAiEngine4 { 
    "GPT-4" = 'gpt-4',
    GPT_4o = 'gpt-4o', // satisfies OpenAI.Chat.ChatModel todo: https://dev.azure.com/BlitsBV/Blits%20Platform/_workitems/edit/3909
    // "GPT-4-0613" = 'gpt-4-0613',
    // "GPT-4-32k" = 'gpt-4-32k',
    // "GPT-4-32k-0613" = 'gpt-4-32k-0613'
};